import session from './session'
import {ENDPOINT} from './index'

export default {
  create (data) {
    return session.post(ENDPOINT + '/manage/create_permission/', data)
  },
  update (data) {
    return session.post(ENDPOINT + '/manage/update_permission/', data)
  },
  remove (id) {
    return session.post(ENDPOINT + '/manage/delete_permission/', {id: id})
  },
  findById (id) {
    return session.post(ENDPOINT + '/manage/get_permission/', {id: id})
  },
  filter (filterData, page, page_size) {
    return session.post(ENDPOINT + '/manage/filter_permission/', {page: page, page_size: page_size, filter: filterData})
  }
}



// WEBPACK FOOTER //
// ./src/api/permission.js